/**
 * @generated SignedSource<<ad692b1dc59f1c5d6c014a9fadeb207d>>
 * @relayHash 467fb997baff7898efacba57030234d3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID eda4dc89a121a5bc1b0d1b38176fb11d857c3c4393cc85125be623e5a4d205b5

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { HorizontalNavJiraInnerQuery } from './HorizontalNavJiraInnerQuery.graphql';

import includeAddAgents_provider from '@jira/platform__graphql-relay-provider/src/AutonomousAgentsInSpaceRelayProvider';
import isCustomTemplateForStandardAndPremiumEnabled_provider from '@jira/platform__graphql-relay-provider/src/CustomTemplateForStandardAndPremiumRelayProvider';
import includeAdminAgentChampionRequests_provider from '@jira/platform__graphql-relay-provider/src/JiraAdminAgentM2ChampionFlowRelayProvider';
import isJiraAgenticSummaryViewEnabled_provider from '@jira/platform__graphql-relay-provider/src/JiraAgenticSummaryViewRelayProvider';
import isJiraExternalGuestsSpaceFlagEnabled_provider from '@jira/platform__graphql-relay-provider/src/JiraExternalGuestsSpaceFlagRelayprovider';
import isBoardActionsFragmentEnabled_provider from '@jira/platform__graphql-relay-provider/src/NavBoardHeaderFragmentRelayProvider';
import isJiraCreateViewWithRovoEnabled_provider from '@jira/platform__graphql-relay-provider/src/Sea3716JiraCreateViewWithRovoRelayprovider';

const node: PreloadableConcreteRequest<HorizontalNavJiraInnerQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "eda4dc89a121a5bc1b0d1b38176fb11d857c3c4393cc85125be623e5a4d205b5",
    "metadata": {},
    "name": "HorizontalNavJiraInnerQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJiraExternalGuestsSpaceFlagRelayprovider": isJiraExternalGuestsSpaceFlagEnabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcSea3716JiraCreateViewWithRovoRelayprovider": isJiraCreateViewWithRovoEnabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJiraAgenticSummaryViewRelayProvider": isJiraAgenticSummaryViewEnabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcNavBoardHeaderFragmentRelayProvider": isBoardActionsFragmentEnabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcAutonomousAgentsInSpaceRelayProvider": includeAddAgents_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcCustomTemplateForStandardAndPremiumRelayProvider": isCustomTemplateForStandardAndPremiumEnabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJiraAdminAgentM2ChampionFlowRelayProvider": includeAdminAgentChampionRequests_provider
    }
  }
};

export default node;
